/**
 * Error type system for PayLOGIK React application
 *
 * Defines semantic error categories and standardized error structure
 * for consistent error handling across the application.
 */

/**
 * Semantic error categories mapped from HTTP status codes and error types
 */
export enum ErrorCategory {
    Network = 'Network',
    Auth = 'Auth',
    Client = 'Client',
    Server = 'Server',
    Unknown = 'Unknown',
}

/**
 * Standardized application error structure
 *
 * Provides consistent error information across all error sources
 * including network failures, API errors, and rendering errors.
 */
export interface AppError {
    /** Semantic category for user-friendly error messaging */
    category: ErrorCategory;

    /** User-friendly error message (no technical jargon) */
    message: string;

    /** Original error object for debugging and technical details */
    originalError: any;

    /** When the error occurred */
    timestamp: Date;

    /** Whether this error can be retried (network/server errors) */
    isRetryable: boolean;

    /** Number of retry attempts made */
    retryCount: number;

    /** Where the error originated (component name, API endpoint) */
    source: string;
}
